const $ = require("jquery");

function saveSetting(setting, value) {
    userSettings[setting] = value;
    localStorage.setItem('userSettings', JSON.stringify(userSettings));
}

function isTrue(setting) {
    return setting !== undefined && (setting === true || setting === "true")
}

$(document).ready(function () {

    /**
     * Expand and collapse buttons
     */
    $("#expand-all-versions").click(function () {
        $(".version-wrapper .selectboxes").addClass("expanded-sticky")
    });
    $("#collapse-all-versions").click(function () {
        $(".version-wrapper .selectboxes").removeClass("expanded-sticky")
    });
    $(".version-wrapper .selectboxes").hover(function () {
        $(this).addClass("expanded");
    }, function () {
        $(this).removeClass("expanded");
    })

    /**
     * Select all selected PHP versions
     */
    function selectDefaultPhpVersion(){
        let id = DEFAULT_PHP;
        $(".php-versions-checkboxes[value='"+id+"']").prop("checked", true);
        $(".php-versions-selector [value='"+id+"']").prop("selected", true);
        $(".php-versions-selector").trigger("change").trigger("change");
        $(".selected-versions").text("(" + id + ")")
    }

    if($("#selected-php-version-from-code").length > 0){
        let versions = $("#selected-php-version-from-code").val().split(",");

        versions.forEach(function (version) {
            $(".php-versions-selector option[value='" + version + "']").prop("selected", true)
            $(".php-versions-checkboxes[value='" + version + "']").prop("checked", true)
        })
        $(".selected-versions").text("(" + versions.join(", ") + ")")
        $(".php-versions-selector").trigger("change");

    }else if(userSettings.phpversions) {
        let selectedVersions = JSON.parse(userSettings.phpversions);
        if(selectedVersions.length < 1){
            selectDefaultPhpVersion()

        }else {
            selectedVersions.forEach(function (version) {
                $(".php-versions-selector option[value='" + version + "']").prop("selected", true)
                $(".php-versions-checkboxes[value='" + version + "']").prop("checked", true)
            })
            $(".selected-versions").text("(" + selectedVersions.join(", ") + ")")
            $(".php-versions-selector").trigger("change");
        }
    }else{
        selectDefaultPhpVersion()
    }

    /**
     * Add Carets and expand functions
     */
    // Show for a sec so the scrollheight works
    $(".accordionContent").show();
    $(".version-wrapper .selectboxes").each(function () {
        let height = $(this).prop("scrollHeight");
        if (height > 25) {
            $(this).closest(".version-wrapper")
                .find(".version-group")
                .click(function () {
                    if ($(this).closest(".version-wrapper").find(".selectboxes").hasClass("expanded-sticky") === false) {
                        $(this).closest(".version-wrapper").find(".selectboxes").addClass("expanded-sticky")
                        $(this).find("i.fas").removeClass("fa-caret-down").addClass("fa-caret-up");
                    } else {
                        $(this).closest(".version-wrapper").find(".selectboxes").removeClass("expanded-sticky")
                        $(this).find("i.fas").removeClass("fa-caret-up").addClass("fa-caret-down");
                    }
                }).addClass("expandable collapsed").find("i")
                .addClass("fas fa-caret-down")
        }
        if($(this).find(":checked").length > 0){
            $(this).closest(".version-wrapper").find(".selectboxes").addClass("expanded-sticky");
            $(this).closest(".version-wrapper").find("i.fas").removeClass("fa-caret-down").addClass("fa-caret-up");
        }
    });
    $(".accordionContent").hide();

    /**
     * Hide PHP list
     */
    if (isTrue(userSettings.hidePHPVerionsList)) {
        $(".version-wrapper").hide();
        $(".php-version-select-options").hide();
        $(".php-version-select-options-hidden").show();
    } else {
        $(".php-version-select-options-hidden").hide();
    }

    $("#hide-all-versions").click(function () {
        $(".version-wrapper").hide();
        $(".php-version-select-options").hide();
        $(".php-version-select-options-hidden").show();
        saveSetting("hidePHPVerionsList", true)
    });
    $("#show-all-versions").click(function () {
        $(".version-wrapper").show();
        $(".php-version-select-options").show();
        $(".php-version-select-options-hidden").hide();
        saveSetting("hidePHPVerionsList", false)
    });
    $("#clear-all-versions").click(function () {
        $(".php-versions-selector option").prop("selected", false)
        $(".php-versions-checkboxes").prop("checked", false)
        $(".php-versions-selector").trigger("change");
        $(".selected-versions").text('')
    });


    /**
     * Link the checkboxes to the selector
     */

    function saveVersions(value, checked){
        let versions = [];
        $(".php-versions-checkboxes").each(function(){
            let val = $(this).val();
            if(value !== val && $(this).is(":checked")){
                versions.push(val);
            }
            if(value === val && checked){
                versions.push(val);
            }
        })
        versions = new Set(versions);

        if(versions.size > 5 && checked){
            alert("Only 5 versions can be selected at this time")
            return false;
        }

        $(".php-versions-checkboxes[value='"+value+"']").prop("checked", checked)
        $(".php-versions-selector option[value='"+value+"']").prop("selected", checked)
        $(".php-versions-selector").trigger("change");

        versions = [...versions];
        $(".selected-versions").text("(" + versions.join(", ") + ")")

        saveSetting("phpversions", JSON.stringify(versions))
    }
    $(".php-versions-checkboxes").click(function(){
        let value = $(this).val();
        let checked = $(this).is(":checked");

        if(checked){
            $(this).closest(".version-wrapper").find(".selectboxes").addClass("expanded-sticky");
            $(this).closest(".version-wrapper").find("i.fas").removeClass("fa-caret-down").addClass("fa-caret-up");
        }

        return saveVersions(value, checked)

    });

    /**
     * Link the selector to the checkboxes
     */
    function versionSelectorSelect(e){
        let id = e.params.data.id;
        let selected = e.params.data.selected
        $(".php-versions-checkboxes[value='"+id+"']").prop("checked", selected);
        if(selected){
            $(".php-versions-checkboxes[value='"+id+"']").closest(".version-wrapper").find(".selectboxes").addClass("expanded-sticky");
            $(".php-versions-checkboxes[value='"+id+"']").closest(".version-wrapper").find("i.fas").removeClass("fa-caret-down").addClass("fa-caret-up");
        }
        return saveVersions(id, selected)

    }
    $(".php-versions-selector").on("select2:select",function(e){
        versionSelectorSelect(e);
    }).on("select2:unselect",function(e){
        versionSelectorSelect(e);
    });





});

